import config from '../config/index'
import handleResponse from './handleResponse'

export default function () {
  let serverWs = config.serverWs
  let context = this
  let vue = null
  this.socket = null

  function getLocalToken () {
    var token = localStorage.token ? localStorage.token : ''
    return token
  }

  this.init = function (vueInstance) {
    vue = vueInstance
    context.start()
    this.mainInterval = setInterval(function () {
      vue.$store.dispatch('updateTime')
    }, 1000)
  }

  this.start = function () {
    const currRoute = vue.$router.resolve(window.location.pathname)

    vue.$router.push({ path: '/' })

    // console.log('connectionString', serverWs + getLocalToken())
    this.socket = new WebSocket(serverWs + getLocalToken())

    this.socket.onopen = function (ev) {
      // console.log(ev)
      if (getLocalToken() === '') {
        // console.log(`not authenticated, redirecting to ${currRoute.resolved.name} page`)

        if (currRoute.resolved.meta.requiresAuth) {
          vue.$router.push({ path: '/login' })
        } else {
          vue.$router.push({ path: currRoute.resolved.path })
        }
      } else {
        context.getInitInfos()
        //   vue.$router.push({path: currRoute.resolved.path})
      }
    }

    this.socket.onmessage = function (ev) {
      let data = JSON.parse(ev.data)

      // console.log(' ----receiving----> ', ev.data + ' ' + Math.random() * 100000)
      vue.$store.dispatch('updatePendingRequests', { cmd: data.cmd, state: false })
      if (data.error && data.error === 'not_authenticated') {
        localStorage.removeItem('token')
        vue.$store.dispatch('resetAppReady')
        vue.$router.push({ path: '/login' })
        return
      }

      if (data.cmd === 'logout' && data.result === 'success') {
        localStorage.removeItem('token')
        vue.$store.dispatch('resetAppReady')
        vue.$router.push({ path: '/login' })
        return
      }

      if (data.cmd === 'ping') {
        context.send(vue.$store.state.ping.response)
        return
      }

      return handleResponse(vue, data)
    }

    this.socket.onclose = function (ev) {
      // console.log('close socket event', ev)
      context.start()
    }
  }

  this.send = function (data) {
    if (getLocalToken() === '' && data.cmd !== 'login') {
      // console.log('need login')
    }
    vue.$store.dispatch('updatePendingRequests', { cmd: data.cmd, state: true })
    data = JSON.stringify(data)
    // console.log('<====sending===== ', data)
    this.socket.send(data)
  }

  this.close = function () {
    this.socket.close()
  }

  // server requests start /////////////////////////////////////////
  this.askAuthentication = function (data) {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    console.log('>>>', uuid)
    vue.$store.dispatch('setRoomForAskAuthenticationRequest', uuid)
    vue.$store.dispatch('setupAskAuthentication', data)
    this.send(vue.$store.state.askAuthentication.request)
  }

  this.getInitInfos = function () {
    this.send({
      cmd: 'init_infos'
    })
  }

  this.getMessages = function () {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForMessageRequest', uuid)
    this.send(vue.$store.state.messages.request)
    vue.$store.dispatch('setRoomForMessageRequest', '')
  }

  this.joinRoom = function () {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    if (!uuid) return // console.log('no UUID for join')
    vue.$store.dispatch('setRoomForJoinRequest', uuid)
    this.send(vue.$store.state.joinRoom.request)
    vue.$store.dispatch('setRoomForJoinRequest', '')
  }

  this.logout = function () {
    vue.$store.dispatch('setCurrentRoom', '')
    this.send({ cmd: 'logout' })
  }

  this.getSkills = function () {
    this.send(vue.$store.state.allSkills.request)
  }

  this.getRooms = function () {
    this.send(vue.$store.state.allRooms.request)
    // also get header stats
    this.send(vue.$store.state.getHeaderStats.request)
  }

  this.getAgents = function (uuid) {
    vue.$store.dispatch('setSkilForAgentRequest', null)
    if (uuid) {
      vue.$store.dispatch('setSkilForAgentRequest', uuid)
    }
    this.send(vue.$store.state.allAgents.request)
    vue.$store.dispatch('setSkilForAgentRequest', '')
  }

  this.closeRoom = function () {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForCloseRequest', uuid)
    this.send(vue.$store.state.closeRoom.request)
    vue.$store.dispatch('setRoomForCloseRequest', '')
    vue.$store.dispatch('setCurrentRoom', '')
  }

  this.blockRoom = function () {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForBlockRequest', uuid)
    this.send(vue.$store.state.blockRoom.request)
    vue.$store.dispatch('setCurrentRoom', '')
    vue.$store.dispatch('resetHistoryResponse')
  }

  this.transferRoom = function () {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForTransferRequest', uuid)
    this.send(vue.$store.state.transferRoom.request)
    vue.$store.dispatch('setRoomForTransferRequest', '')
    vue.$store.dispatch('setSKillForTransferRequest', '')
    vue.$store.dispatch('setCurrentRoom', '')
    vue.$store.dispatch('resetHistoryResponse')
  }

  this.getHistory = function () {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForHistoryRequest', uuid)
    this.send(vue.$store.state.getHistory.request)
    vue.$store.dispatch('setRoomForHistoryRequest', '')
  }

  this.sendMessage = function () {
    let msg = vue.$store.getters.getSendMessageRequestObject.content
    // console.log(msg)
    if (!msg) {
      return // console.log('no msg to send')
    }
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForSendMessage', uuid)
    this.send(vue.$store.state.sendMessage.request)
    vue.$store.dispatch('setRoomForSendMessage', '')
    vue.$store.dispatch('setContentForSendMessage', '')
  }

  this.getAgentSettings = function (uuid) {
    vue.$store.dispatch('setAgentUuidForSettingsRequest', uuid)
    this.send(vue.$store.state.agentSettings.request)
    vue.$store.dispatch('setAgentUuidForSettingsRequest', '')
  }

  this.getOwnSettings = function () {
    this.send(vue.$store.state.ownSettings.request)
  }

  this.togglePause = function () {
    this.send(vue.$store.state.pause.request)
  }

  this.getMessagesFromHistory = function (eventUuid) {
    if (!eventUuid) return // console.log('eventUuid missing for history request')
    vue.$store.dispatch('setFromeventForMessageRequest', eventUuid)
    this.getMessages()
    vue.$store.dispatch('setFromeventForMessageRequest', null)
  }

  this.getProducts = function () {
    vue.$store.dispatch('resetGetProductsResponse')
    this.send(vue.$store.state.getProducts.request)
  }

  this.sendProducts = function (productsArray) {
    if (productsArray.length === 0) {
      return // console.log('nothing to send')
    }
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForSendProductsRequest', uuid)
    vue.$store.dispatch('setContentForSendProducts', productsArray)
    this.send(vue.$store.state.sendProducts.request)
    vue.$store.dispatch('resetGetProductsResponse')
    vue.$store.dispatch('setRoomForSendProductsRequest', '')
    vue.$store.dispatch('setContentForSendProducts', [])
  }

  this.sendLocations = function (locationsArray) {
    // console.log('productsArray', locationsArray)
    if (locationsArray.length === 0) {
      return // console.log('nothing to send')
    }
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForSendLocationsRequest', uuid)
    vue.$store.dispatch('setContentForSendLocations', locationsArray)
    this.send(vue.$store.state.sendLocations.request)
    vue.$store.dispatch('setRoomForSendLocationsRequest', '')
    vue.$store.dispatch('setContentForSendLocations', [])
  }

  this.sendPayment = function (payment) {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForSendPaymentRequest', uuid)
    vue.$store.dispatch('sendPayment', payment)
    this.send(vue.$store.state.sendPayment.request)
  }

  this.getStats = function (interval) {
    vue.$store.dispatch('resetGetStats')
    if (!interval) {
      return // console.log('no interval for stats')
    }
    vue.$store.dispatch('setIntervalForGetStats', interval)
    this.send(vue.$store.state.getStats.request)
    vue.$store.dispatch('resetIntervalForGetStats')
  }

  this.getCsvStats = function (interval) {
    vue.$store.dispatch('resetGetCsvStats')
    if (!interval) {
      return // console.log('no interval for stats')
    }
    vue.$store.dispatch('setIntervalForGetCsvStats', interval)
    this.send(vue.$store.state.getCsvStats.request)
    vue.$store.dispatch('resetIntervalForGetCsvStats')
  }

  this.getSupervisorStats = function (params) {
    vue.$store.dispatch('resetGetSupervisorStats')
    vue.$store.dispatch('resetParamsForGetSupervisorStats')
    if (!params.interval) {
      return // console.log('no interval for stats')
    }
    if (params.interval) {
      vue.$store.dispatch('setIntervalForGetSupervisorStats', params.interval)
    }
    if (params.agent) {
      vue.$store.dispatch('setAgentForGetSupervisorStats', params.agent)
    }
    if (params.skill) {
      vue.$store.dispatch('setSkillForGetSupervisorStats', params.skill)
    }
    this.send(vue.$store.state.getSupervisorStats.request)
    vue.$store.dispatch('resetParamsForGetSupervisorStats')
  }

  this.getSupervisorCsvStats = function (params) {
    vue.$store.dispatch('resetGetSupervisorCsvStats')
    vue.$store.dispatch('resetParamsForGetSupervisorCsvStats')
    if (!params.interval) {
      return // console.log('no interval for stats')
    }
    if (params.interval) {
      vue.$store.dispatch('setIntervalForGetSupervisorCsvStats', params.interval)
    }
    if (params.agent) {
      vue.$store.dispatch('setAgentForGetSupervisorCsvStats', params.agent)
    }
    if (params.skill) {
      vue.$store.dispatch('setSkillForGetSupervisorCsvStats', params.skill)
    }
    this.send(vue.$store.state.getSupervisorCsvStats.request)
    vue.$store.dispatch('resetParamsForGetSupervisorCsvStats')
  }

  this.getNotes = function () {
    vue.$store.dispatch('resetGetNotes')
    let uuid = vue.$store.getters.getCurrentRoomUuid
    if (!uuid) return // console.log('current room is not set')
    vue.$store.dispatch('updateRoomForGetNotes', uuid)
    this.send(vue.$store.state.getNotes.request)
    vue.$store.dispatch('resetRoomForGetNotes')
  }

  this.sendNote = function () {
    let uuid = vue.$store.getters.getCurrentRoomUuid
    if (!uuid) return // console.log('no room selected')
    let data = vue.$store.getters.getSendNoteRequest
    if (!data.subject) return // console.log('no subject selected')
    if (!data.content) return // console.log('no content selected')
    vue.$store.dispatch('setRoomForSendNote', uuid)
    this.send(vue.$store.state.sendNote.request)
    vue.$store.dispatch('resetSendNoteRequest')
  }

  this.getZencalls = function () {
    this.send(vue.$store.state.getZencalls.request)
  }

  this.launchZencall = function (zencallId) {
    if (!zencallId) return // console.log('zencallId missing for zencall')
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForLaunchZencall', uuid)
    vue.$store.dispatch('setZencallForLaunchZencall', zencallId)
    this.send(vue.$store.state.launchZencall.request)
    vue.$store.dispatch('resetLaunchZencallRequest')
  }

  this.sendFiles = function (file) {
    if (!file) {
      return // console.log('nothing to send')
    }
    let uuid = vue.$store.getters.getCurrentRoomUuid
    vue.$store.dispatch('setRoomForSendFilesRequest', uuid)
    vue.$store.dispatch('setContentForSendFiles', file)
    this.send(vue.$store.state.sendFiles.request)
    vue.$store.dispatch('resetSendFilesRequest', '')
  }
}
